export default __webpack_public_path__ + "retailcef516.png";